import { createSelector } from 'reselect';

export const selectTrendingAndSeasonalOffers = state => state.trendingAndSeasonalOffers;
export const selectTrendingAndSeasonalOffersConfig = createSelector(
  selectTrendingAndSeasonalOffers,
  trendingAndSeasonalOffers => trendingAndSeasonalOffers.config,
);

export const selectTrendingAndSeasonalOffersIsLoading = createSelector(
  selectTrendingAndSeasonalOffers,
  trendingAndSeasonalOffers => trendingAndSeasonalOffers.isLoading,
);

export const selectTrendingAndSeasonalOffersIsLoaded = createSelector(
  selectTrendingAndSeasonalOffers,
  trendingAndSeasonalOffers => trendingAndSeasonalOffers.isLoaded,
);

export const selectTrendingAndSeasonalOffersData = createSelector(
  selectTrendingAndSeasonalOffers,
  trendingAndSeasonalOffers => trendingAndSeasonalOffers.offers,
);
